import useUrlQueryParams from "./useUrlQueryParams";

/**
 * Hook to extract HubSpot UTM query parameters from the URL and return them
 * as a URLSearchParams object. Only includes parameters that are present in the URL.
 *
 * Includes the following UTM parameters:
 * - utm_source: Campaign source (e.g., google, newsletter)
 * - utm_medium: Campaign medium (e.g., cpc, email, social)
 * - utm_campaign: Campaign name
 * - utm_term: Paid keyword terms
 * - utm_content: Content identifier for A/B testing
 * - utm_id: Campaign ID
 *
 * @returns URLSearchParams object containing only the UTM parameters present in the URL
 *
 * @example
 * const utmParams = useHubSpotUTMQueryParams();
 * // Use with API calls:
 * const url = `/api/submit?${utmParams.toString()}`;
 */
const useHubSpotUTMQueryParams = (): URLSearchParams => {
  const {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
    utm_id
  } = useUrlQueryParams();

  const queryParams = new URLSearchParams();
  if (utm_source) queryParams.set("utm_source", utm_source);
  if (utm_medium) queryParams.set("utm_medium", utm_medium);
  if (utm_campaign) queryParams.set("utm_campaign", utm_campaign);
  if (utm_term) queryParams.set("utm_term", utm_term);
  if (utm_content) queryParams.set("utm_content", utm_content);
  if (utm_id) queryParams.set("utm_id", utm_id);

  return queryParams;
};

export default useHubSpotUTMQueryParams;
